import { render, staticRenderFns } from "./HuchaAlt.vue?vue&type=template&id=0c8058e4&scoped=true"
import script from "./HuchaAlt.vue?vue&type=script&lang=js"
export * from "./HuchaAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8058e4",
  null
  
)

export default component.exports